import { render, staticRenderFns } from "./MultipleUploadsTooltip.vue?vue&type=template&id=473cf864"
import script from "./MultipleUploadsTooltip.vue?vue&type=script&lang=js"
export * from "./MultipleUploadsTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports